// Per-staff scoped realtime session (roadmap #88). Bridges the corporate identity already
// verified by the backend into the realtime data layer: right after login, before the presence
// tree (deviceSession) is first touched, this exchanges a backend-minted, tenant/user-scoped
// session token for a signed-in session, replacing the anonymous one every client starts with
// (core/firebase.ts). Nothing here can select another tenant or user — the token is minted
// server-side from the caller's own verified session (no client input feeds it).
import { signInWithCustomToken } from 'firebase/auth'
import { auth } from '../core/firebase'
import { httpRequest } from '../core/http'

export const establishStaffRealtimeSession = async (): Promise<void> => {
  try {
    const response = await httpRequest('realtime-session/token', 'POST', {})
    const sessionToken = response?.data?.sessionToken
    if (!sessionToken) {
      // FAIL-OPEN: keep the anonymous session so the presence tree / call flow still work;
      // only the per-user scoping is missed until a subsequent login succeeds.
      console.log('realtime session: no session token issued, staying on the anonymous session')
      return
    }
    await signInWithCustomToken(auth, sessionToken)
  } catch (e) {
    console.log('realtime session: could not establish the scoped session', e)
  }
}
